<script lang="ts">
  import { Icon } from '@steeze-ui/svelte-icon';
  import { XCircle, InformationCircle } from '@steeze-ui/heroicons';

  export let severity: 'danger' | 'notice' | 'success' | 'warning';
  export let messages: string[] | undefined = undefined;
</script>

{#if severity === 'danger'}
  <div class="rounded-md bg-red-50 p-4 my-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <Icon src={XCircle} class="h-6 w-6 mr-2 text-red-400" />
      </div>
      <div class="ml-3">
        {#if Array.isArray(messages) && messages?.length > 1}
          <h3 class="text-sm font-medium text-red-700">Ocurrieron los siguientes errores:</h3>
        {/if}
        <div class="mt-2 text-sm text-red-700">
          {#if Array.isArray(messages) && messages?.length > 0}
            {#if messages?.length > 1}
              <ul class="list-disc pl-5 space-y-1">
                {#each messages as err}
                  <li>{err}</li>
                {/each}
              </ul>
            {:else}
              {messages[0]}
            {/if}
          {/if}
          <slot />
        </div>
      </div>
    </div>
  </div>
{:else if severity === 'notice'}
  <div class="rounded-md bg-blue-50 p-4 my-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <Icon src={InformationCircle} class="h-6 w-6 mr-2 text-blue-400" />
      </div>
      <div class="ml-3">
        <div class="mt-2 text-sm text-blue-700">
          {#if Array.isArray(messages)}
            <ul class="list-disc pl-5 space-y-1">
              {#each messages as err}
                <li>{err}</li>
              {/each}
            </ul>
          {/if}
          <slot />
        </div>
      </div>
    </div>
  </div>
{:else if severity === 'success'}
  <div class="rounded-md bg-green-50 p-4 my-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <Icon src={InformationCircle} class="h-6 w-6 mr-2 text-green-400" />
      </div>
      <div class="ml-3">
        <div class="mt-2 text-sm text-green-700">
          {#if Array.isArray(messages)}
            <ul class="list-disc pl-5 space-y-1">
              {#each messages as err}
                <li>{err}</li>
              {/each}
            </ul>
          {/if}
          <slot />
        </div>
      </div>
    </div>
  </div>
{:else if severity === 'warning'}
  <div class="rounded-md bg-yellow-50 p-4 my-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <Icon src={InformationCircle} class="h-6 w-6 mr-2 text-yellow-400" />
      </div>
      <div class="ml-3">
        <div class="mt-2 text-sm text-yellow-700">
          {#if Array.isArray(messages)}
            <ul class="list-disc pl-5 space-y-1">
              {#each messages as err}
                <li>{err}</li>
              {/each}
            </ul>
          {/if}
          <slot />
        </div>
      </div>
    </div>
  </div>
{/if}
